import { createRouter, createWebHashHistory } from "vue-router";
import AdminHomeView from "../components/AdminHome.vue"
import AddProduct from "../components/addproduct.vue"
import Home from "../views/Home.vue"
import PetIndex from "../views/pet/index.vue"

const routes = [

    {
        path: "/",
        component: Home,
        children: [
        ]
    },
    {
        path: "/admin",
        component: AdminHomeView,
        children: [
            // 默认子路由：进入/admin时显示欢迎页
            {
                path: "",
                component: () => import("../components/Welcome.vue")
            },
            // 系统信息管理下的子路由
            {
                path: "fileTree", // 资源树查询
                component: () => import("../components/source/ResourceTree.vue")
            },
            {
                path: "files", // 文件管理
                component: () => import("../components/file/FilesView.vue")
            },
            {
                path: "catalogInfo", // 目录管理（仅管理员可见）
                component: () => import("../components/catalog/CatalogInfo.vue")
            },
            {
                path: "sourceInfo", // 资源管理
                component: () => import("../components/source/SourseInfo.vue")
            },
            {
                path: "addSource", // 资源新增
                component: () => import("../components/source/AddSourse.vue")
            }


        ]
    },
    //寻宠物的
    {
        path: "/pet",
        component: PetIndex,
         children: [
            // 默认子路由：进入/admin时显示欢迎页
            {
                path: "",
                component: () => import("../components/Welcome.vue")
            },
            {
                path: "carousel", 
                component: () => import("../views/pet/carousel/CarouselView.vue")
            },
            {
                path: "stats", 
                component: () => import("../views/pet/stats/StatsView.vue")
            },
            {
                path: "users", 
                component: () => import("../views/pet/users/UsersView.vue")
            },
            {
                path: "infos", 
                component: () => import("../views/pet/info/InfoView.vue")
            }

        ]
    },
    {
        path: "/login",
        component: () => import("../components/login.vue")
    },
    {
        path: "/register",
        component: () => import("../components/register.vue")
    }

]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

router.beforeEach((to, from, next) => {

    // 检查用户是否已登录
    const isAuthenticated = sessionStorage.getItem("s") === "true";
    if (to.path === '/login' || to.path === '/register' || to.path === '/') {
        // 如果用户已登录，并且尝试访问登录或注册页面，则重定向到首页
        next();
    } else {
        // 如果用户已登录，则允许访问其他页面；如果未登录，则重定向到登录页面
        if (isAuthenticated) {
            next();
        } else {

            // 如果当前路由是登录页，则直接放行，避免无限重定向
            if (to.path === '/login') {
                next();
            } else {
                next('/login');
            }
        }
    }

})

export default router;